<template>
  <div class="DiagnoseUserRule">
    <p v-html="data"></p>
  </div>
</template>

<script>
export default {
  name: "DiagnoseUserRule",
  data() {
    return {
      data:
        '<html xmlns:v="urn:schemas-microsoft-com:vml"\n' +
        'xmlns:o="urn:schemas-microsoft-com:office:office"\n' +
        'xmlns:w="urn:schemas-microsoft-com:office:word"\n' +
        'xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"\n' +
        'xmlns="http://www.w3.org/TR/REC-html40">\n' +
        "\n" +
        "<head>\n" +
        '<meta http-equiv=Content-Type content="text/html; charset=gb2312">\n' +
        "<meta name=ProgId content=Word.Document>\n" +
        '<meta name=Generator content="Microsoft Word 12">\n' +
        '<meta name=Originator content="Microsoft Word 12">\n' +
        '<link rel=File-List href="使用协议(1).files/filelist.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <o:DocumentProperties>\n" +
        "  <o:Author>Lyz</o:Author>\n" +
        "  <o:LastAuthor>W10</o:LastAuthor>\n" +
        "  <o:Revision>2</o:Revision>\n" +
        "  <o:TotalTime>15</o:TotalTime>\n" +
        "  <o:Created>2021-04-28T01:50:00Z</o:Created>\n" +
        "  <o:LastSaved>2021-04-28T01:50:00Z</o:LastSaved>\n" +
        "  <o:Pages>6</o:Pages>\n" +
        "  <o:Words>539</o:Words>\n" +
        "  <o:Characters>3073</o:Characters>\n" +
        "  <o:Lines>25</o:Lines>\n" +
        "  <o:Paragraphs>7</o:Paragraphs>\n" +
        "  <o:CharactersWithSpaces>3605</o:CharactersWithSpaces>\n" +
        "  <o:Version>12.00</o:Version>\n" +
        " </o:DocumentProperties>\n" +
        " <o:OfficeDocumentSettings>\n" +
        "  <o:AllowPNG/>\n" +
        " </o:OfficeDocumentSettings>\n" +
        "</xml><![endif]-->\n" +
        '<link rel=themeData href="使用协议(1).files/themedata.thmx">\n' +
        '<link rel=colorSchemeMapping href="使用协议(1).files/colorschememapping.xml">\n' +
        "<!--[if gte mso 9]><xml>\n" +
        " <w:WordDocument>\n" +
        "  <w:TrackMoves>false</w:TrackMoves>\n" +
        "  <w:TrackFormatting/>\n" +
        "  <w:PunctuationKerning/>\n" +
        "  <w:DrawingGridVerticalSpacing>7.8 磅</w:DrawingGridVerticalSpacing>\n" +
        "  <w:DisplayHorizontalDrawingGridEvery>0</w:DisplayHorizontalDrawingGridEvery>\n" +
        "  <w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery>\n" +
        "  <w:ValidateAgainstSchemas/>\n" +
        "  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>\n" +
        "  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>\n" +
        "  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>\n" +
        "  <w:DoNotPromoteQF/>\n" +
        "  <w:LidThemeOther>EN-US</w:LidThemeOther>\n" +
        "  <w:LidThemeAsian>ZH-CN</w:LidThemeAsian>\n" +
        "  <w:LidThemeComplexScript>X-NONE</w:LidThemeComplexScript>\n" +
        "  <w:Compatibility>\n" +
        "   <w:SpaceForUL/>\n" +
        "   <w:BalanceSingleByteDoubleByteWidth/>\n" +
        "   <w:DoNotLeaveBackslashAlone/>\n" +
        "   <w:ULTrailSpace/>\n" +
        "   <w:DoNotExpandShiftReturn/>\n" +
        "   <w:AdjustLineHeightInTable/>\n" +
        "   <w:BreakWrappedTables/>\n" +
        "   <w:SnapToGridInCell/>\n" +
        "   <w:WrapTextWithPunct/>\n" +
        "   <w:UseAsianBreakRules/>\n" +
        "   <w:DontGrowAutofit/>\n" +
        "   <w:SplitPgBreakAndParaMark/>\n" +
        "   <w:DontVertAlignCellWithSp/>\n" +
        "   <w:DontBreakConstrainedForcedTables/>\n" +
        "   <w:DontVertAlignInTxbx/>\n" +
        "   <w:Word11KerningPairs/>\n" +
        "   <w:CachedColBalance/>\n" +
        "   <w:UseFELayout/>\n" +
        "  </w:Compatibility>\n" +
        "  <m:mathPr>\n" +
        '   <m:mathFont m:val="Cambria Math"/>\n' +
        '   <m:brkBin m:val="before"/>\n' +
        '   <m:brkBinSub m:val="--"/>\n' +
        "   <m:smallFrac/>\n" +
        "   <m:dispDef/>\n" +
        '   <m:lMargin m:val="0"/>\n' +
        '   <m:rMargin m:val="0"/>\n' +
        '   <m:defJc m:val="centerGroup"/>\n' +
        '   <m:wrapIndent m:val="1440"/>\n' +
        '   <m:intLim m:val="subSup"/>\n' +
        '   <m:naryLim m:val="undOvr"/>\n' +
        "  </m:mathPr></w:WordDocument>\n" +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="true"\n' +
        '  DefSemiHidden="true" DefQFormat="false" DefPriority="99"\n' +
        '  LatentStyleCount="267">\n' +
        '  <w:LsdException Locked="false" Priority="0" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Normal"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="heading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 7"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 8"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" Name="toc 9"/>\n' +
        '  <w:LsdException Locked="false" Priority="35" QFormat="true" Name="caption"/>\n' +
        '  <w:LsdException Locked="false" Priority="10" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" Name="Default Paragraph Font"/>\n' +
        '  <w:LsdException Locked="false" Priority="11" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtitle"/>\n' +
        '  <w:LsdException Locked="false" Priority="22" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Strong"/>\n' +
        '  <w:LsdException Locked="false" Priority="20" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Table Grid"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Placeholder Text"/>\n' +
        '  <w:LsdException Locked="false" Priority="1" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="No Spacing"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" UnhideWhenUsed="false" Name="Revision"/>\n' +
        '  <w:LsdException Locked="false" Priority="34" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="List Paragraph"/>\n' +
        '  <w:LsdException Locked="false" Priority="29" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="30" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Quote"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 1"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 2"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 3"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 4"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 5"/>\n' +
        '  <w:LsdException Locked="false" Priority="60" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="61" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="62" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Light Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="63" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="64" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Shading 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="65" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="66" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium List 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="67" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 1 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="68" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 2 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="69" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Medium Grid 3 Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="70" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Dark List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="71" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Shading Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="72" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful List Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="73" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" Name="Colorful Grid Accent 6"/>\n' +
        '  <w:LsdException Locked="false" Priority="19" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="21" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Emphasis"/>\n' +
        '  <w:LsdException Locked="false" Priority="31" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Subtle Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="32" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Intense Reference"/>\n' +
        '  <w:LsdException Locked="false" Priority="33" SemiHidden="false"\n' +
        '   UnhideWhenUsed="false" QFormat="true" Name="Book Title"/>\n' +
        '  <w:LsdException Locked="false" Priority="37" Name="Bibliography"/>\n' +
        '  <w:LsdException Locked="false" Priority="39" QFormat="true" Name="TOC Heading"/>\n' +
        " </w:LatentStyles>\n" +
        "</xml><![endif]-->\n" +
        "<style>\n" +
        "<!--\n" +
        " /* Font Definitions */\n" +
        " @font-face\n" +
        "\t{font-family:宋体;\n" +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-alt:SimSun;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"Cambria Math";\n' +
        "\tpanose-1:2 4 5 3 5 4 6 3 2 4;\n" +
        "\tmso-font-charset:1;\n" +
        "\tmso-generic-font-family:roman;\n" +
        "\tmso-font-format:other;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:0 0 0 0 0 0;}\n" +
        "@font-face\n" +
        "\t{font-family:Calibri;\n" +
        "\tpanose-1:2 15 5 2 2 2 4 3 2 4;\n" +
        "\tmso-font-charset:0;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-469750017 -1073732485 9 0 511 0;}\n" +
        "@font-face\n" +
        "\t{font-family:微软雅黑;\n" +
        "\tpanose-1:2 11 5 3 2 2 4 2 2 4;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-2147483001 718224464 22 0 262175 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@微软雅黑";\n' +
        "\tpanose-1:2 11 5 3 2 2 4 2 2 4;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:swiss;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:-2147483001 718224464 22 0 262175 0;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@宋体";\n' +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;\n" +
        "\tmso-font-charset:134;\n" +
        "\tmso-generic-font-family:auto;\n" +
        "\tmso-font-pitch:variable;\n" +
        "\tmso-font-signature:3 680460288 22 0 262145 0;}\n" +
        " /* Style Definitions */\n" +
        " p.MsoNormal, li.MsoNormal, div.MsoNormal\n" +
        "\t{mso-style-unhide:no;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:justify;\n" +
        "\ttext-justify:inter-ideograph;\n" +
        "\tmso-pagination:none;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p.MsoHeader, li.MsoHeader, div.MsoHeader\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页眉 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:center;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tborder:none;\n" +
        "\tmso-border-bottom-alt:solid windowtext .75pt;\n" +
        "\tpadding:0cm;\n" +
        "\tmso-padding-alt:0cm 0cm 1.0pt 0cm;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p.MsoFooter, li.MsoFooter, div.MsoFooter\n" +
        "\t{mso-style-priority:99;\n" +
        '\tmso-style-link:"页脚 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\tmso-pagination:none;\n" +
        "\ttab-stops:center 207.65pt right 415.3pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-fareast-font-family:宋体;\n" +
        "\tmso-fareast-theme-font:minor-fareast;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "p\n" +
        "\t{mso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-margin-top-alt:auto;\n" +
        "\tmargin-right:0cm;\n" +
        "\tmso-margin-bottom-alt:auto;\n" +
        "\tmargin-left:0cm;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tmso-bidi-font-family:宋体;}\n" +
        "span.pt\n" +
        "\t{mso-style-name:pt;\n" +
        "\tmso-style-unhide:no;}\n" +
        "span.Char\n" +
        '\t{mso-style-name:"页眉 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页眉;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        "span.Char0\n" +
        '\t{mso-style-name:"页脚 Char";\n' +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-unhide:no;\n" +
        "\tmso-style-locked:yes;\n" +
        "\tmso-style-link:页脚;\n" +
        "\tmso-ansi-font-size:9.0pt;\n" +
        "\tmso-bidi-font-size:9.0pt;}\n" +
        ".MsoChpDefault\n" +
        "\t{mso-style-type:export-only;\n" +
        "\tmso-default-props:yes;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;}\n" +
        " /* Page Definitions */\n" +
        " @page\n" +
        "\t{mso-page-border-surround-header:no;\n" +
        "\tmso-page-border-surround-footer:no;\n" +
        '\tmso-footnote-separator:url("使用协议\\(1\\).files/header.htm") fs;\n' +
        '\tmso-footnote-continuation-separator:url("使用协议\\(1\\).files/header.htm") fcs;\n' +
        '\tmso-endnote-separator:url("使用协议\\(1\\).files/header.htm") es;\n' +
        '\tmso-endnote-continuation-separator:url("使用协议\\(1\\).files/header.htm") ecs;}\n' +
        "@page Section1\n" +
        "\t{size:595.3pt 841.9pt;\n" +
        "\tmargin:72.0pt 90.0pt 72.0pt 90.0pt;\n" +
        "\tmso-header-margin:42.55pt;\n" +
        "\tmso-footer-margin:49.6pt;\n" +
        "\tmso-paper-source:0;\n" +
        "\tlayout-grid:15.6pt;}\n" +
        "div.Section1\n" +
        "\t{page:Section1;}\n" +
        "-->\n" +
        "</style>\n" +
        "<!--[if gte mso 10]>\n" +
        "<style>\n" +
        " /* Style Definitions */\n" +
        " table.MsoNormalTable\n" +
        "\t{mso-style-name:普通表格;\n" +
        "\tmso-tstyle-rowband-size:0;\n" +
        "\tmso-tstyle-colband-size:0;\n" +
        "\tmso-style-noshow:yes;\n" +
        "\tmso-style-priority:99;\n" +
        "\tmso-style-qformat:yes;\n" +
        '\tmso-style-parent:"";\n' +
        "\tmso-padding-alt:0cm 5.4pt 0cm 5.4pt;\n" +
        "\tmso-para-margin:0cm;\n" +
        "\tmso-para-margin-bottom:.0001pt;\n" +
        "\tmso-pagination:widow-orphan;\n" +
        "\tfont-size:10.5pt;\n" +
        "\tmso-bidi-font-size:11.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";\n' +
        "\tmso-ascii-font-family:Calibri;\n" +
        "\tmso-ascii-theme-font:minor-latin;\n" +
        "\tmso-hansi-font-family:Calibri;\n" +
        "\tmso-hansi-theme-font:minor-latin;\n" +
        '\tmso-bidi-font-family:"Times New Roman";\n' +
        "\tmso-bidi-theme-font:minor-bidi;\n" +
        "\tmso-font-kerning:1.0pt;}\n" +
        "</style>\n" +
        "<![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapedefaults v:ext="edit" spidmax="5122"/>\n' +
        "</xml><![endif]--><!--[if gte mso 9]><xml>\n" +
        ' <o:shapelayout v:ext="edit">\n' +
        '  <o:idmap v:ext="edit" data="1"/>\n' +
        " </o:shapelayout></xml><![endif]-->\n" +
        "</head>\n" +
        "\n" +
        "<body lang=ZH-CN style='tab-interval:21.0pt;text-justify-trim:punctuation'>\n" +
        "\n" +
        "<div class=Section1 style='layout-grid:15.6pt'>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>欢迎阅读《<span lang=EN-US>APP</span>用户服务协议》<span lang=EN-US>(</span>以下简称“本协议”<span\n" +
        "lang=EN-US>)</span>。本协议阐述之条款和条件适用于您（以下简称“用户”）使用<span lang=EN-US>APP</span>的各种产品和服务。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>1. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>服务协议的确认</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>1.1</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>北京云圈科技有限公司及相关关联企业（以下合称“云圈公司”）同意按照本协议的规定及其不时发布的操作规则提供基于互联网移动网的<a\n" +
        'name="_GoBack"></a><span lang=EN-US>APP</span>相关服务（以下简称“云圈服务”）。<span\n' +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>1.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈服务使用人（以下简称“用户”）应当基于了解本协议全部内容、在独立思考的基础上认可、同意本协议的全部条款并按照页面上的提示完成全部的注册程序，用户的注册、登录、使用等行为将视为完全接受本协议及云圈公司公示的各项规则、规范。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>1.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司享有对云圈<span lang=EN-US>APP</span>上一切活动的监督、提示、检查、纠正等权利。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>2. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>服务内容</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>2.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈服务的具体内容由云圈公司根据实际情况提供，包括但不限于授权用户通过其帐号上传、搜索并向互相关联的用户推送相关信息、授权用户对其进行收录、分享等，云圈公司有权对其提供的服务或产品形态进行升级或其他调整，均以<span\n" +
        "lang=EN-US>APP\\</span>网站内容更新的方式通知用户，不单独通知用户。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>2.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司提供的云圈服务中可能包括广告，用户同意在使用过程中显示云圈和第三方供应商、合作伙伴提供的广告。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>2.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司仅提供与云圈服务相关的技术服务等，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>3. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>服务变更、中断或终止</span></b></span><span lang=EN-US style='font-size:\n" +
        '10.5pt;font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>3.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>鉴于网络服务的特殊性（包括但不限于不可抗力、网络稳定性、系统稳定性、技术故障、用户所在位置、用户关机、用户手机病毒或恶意的网络攻击行为及其他任何技术、互联网络、通信线路、内容侵权等原因），用户同意，云圈公司有权随时中断或终止部分或全部云圈服务，云圈公司将尽可能及时以合理方式通知用户，并尽可能在第一时间对此进行修复。但对因此导致用户不能发送和接受阅读信息、或接发错信息，云圈公司不承担任何责任，用户须承担以上风险。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>3.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户理解，云圈公司需要定期或不定期地对提供云圈服务的平台或相关设备进行检修和维护，如因此类情况而造成服务在合理期间内的中断，云圈公司将尽可能事先通知，但无需为此承担任何责任。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>3.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户提供的个人资料不真实、用户违反法律法规国家政策或本协议规定的使用规则，云圈公司有权随时中断或终止向用户提供本协议项下的云圈服务，而无需对用户或任何第三方承担任何责任。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>4. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>使用规则</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户在申请注册云圈服务时，必须向云圈公司提供准确的主体资料（用户为个人时，包括姓名、电话等；用户为单位时，包括名称、注册地址、注册号等），如主体资料有任何变动，必须及时更新。因用户提供资料的真实性问题导致协议双方或第三方的任何损失均由用户承担。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户注册成功后，将获得一个云圈帐号及由用户设置的密码，该用户帐号和密码由用户负责保管；用户应当对该用户帐号所有行为负相关法律责任。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户在使用云圈服务过程中，必须遵循以下原则<span lang=EN-US>:<o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(1) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>遵守中国有关的法律和法规；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(2) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>不得为任何非法目的而使用云圈服务；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(3) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>遵守所有与网络服务有关的网络协议、规定和程序；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(4) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>不得利用云圈服务系统进行任何可能对互联网的正常运转造成不利影响的行为；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(5) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>不得利用云圈网络服务系统进行任何不利于云圈公司的行为。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户不得使用云圈服务制作、上传、发送、传播敏感信息和违反国家法律制度的信息，包括但不限于下列信息<span\n" +
        "lang=EN-US>:<o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(1) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>反对宪法所确定的基本原则的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(2) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(3) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>损害国家荣誉和利益的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(4) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>煽动民族仇恨、民族歧视，破坏民族团结的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(5) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>破坏国家宗教政策，宣扬邪教和封建迷信的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(6) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>散布谣言，扰乱社会秩序，破坏社会稳定的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(7) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(8) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>侮辱或者诽谤他人，侵害他人合法权益的；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(9) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>含有法律、行政法规禁止的其他内容的。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.4 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户同意在任何情况下不使用其他用户的帐号或密码。在您怀疑他人在使用您的帐号或密码时，您同意立即通知云圈公司。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.5 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户有权更改、删除在云圈服务中的个人资料、注册信息及传送内容等，但删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.6 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>如因用户违反本协议中的任何条款，云圈公司有权依据本协议终止对违约用户云圈帐号提供服务。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>4.7 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>如用户注册云圈帐号后长期不登录该帐号，云圈公司有权回收该帐号，以免造成资源浪费，由此带来问题均由用户自行承担。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>5. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>知识产权</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>5.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司提供云圈服务中所包含的任何文本、图片、标识、音频、视频资料均受著作权、商标权、专利权及其他财产权法律的保护。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>5.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>未经相关权利人和云圈公司的同意，上述资料均不得以任何方式被展示于其他任何第三方平台或被用于其他任何商业目的；用户不得擅自复制、修改、编纂上述内容、或创造与内容有关的衍生产品。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>6. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>隐私保护</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>6.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>本协议所指的“隐私”包括《电信和互联网用户个人信息保护规定》第<span lang=EN-US>4</span>条规定的用户个人信息的内容以及未来不时制定或修订的法律法规中明确规定的隐私应包括的内容。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>6.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>保护用户隐私和个人数据是云圈公司的一项基本制度，云圈公司将采取各种制度、安全技术和程序等措施来保护用户隐私和个人数据不被未经授权的访问、使用或泄漏，并保证不会将单个用户的注册资料及用户在使用云圈服务时存储在云圈公司的非公开内容向除合作单位以外的第三方公开或用于任何非法的用途，但下列情况除外：<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(1) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>事先获得用户的明确授权；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(2) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>根据有关法律法规的要求；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(3) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>按照相关政府主管部门的要求；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(4) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>为维护社会公众的利益；<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>(5) </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户侵害本协议项下云圈公司的合法权益的情况下而为维护云圈公司的合法权益所必须。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>6.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户在注册云圈<span lang=EN-US>APP</span>帐号或使用云圈<span lang=EN-US>APP</span>服务的过程中，需要提供一些必要的信息，例如：姓名、电话等。为向用户提供帐号注册服务或进行用户身份识别，需要用户填写手机号码；部分功能需要用户授权使用用户的相机或相册；部分功能需要用户授权访问用户的手机通讯录等。若用户不授权或提供的信息不完整，则无法使用本服务或在使用过程中受到限制。用户授权提供的信息，云圈公司承诺将采取措施保护用户的个人信息安全。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>6.4 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>为了向用户提供更好的用户体验和提高云圈<span lang=EN-US>APP</span>的服务质量，云圈公司将可能会收集使用或向第三方提供用户的非个人隐私信息。云圈公司将对该第三方使用用户个人数据的行为进行监督和管理，尽一切可能努力保护用户个人信息的安全。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>7. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>免责声明</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>7.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户在使用云圈服务的过程中应遵守国家法律法规及政策规定，对其所制作、上传、发送、传播的信息和内容承担任何法律责任，与云圈公司无关。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>7.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈<span lang=EN-US>APP</span>在其页面上向用户显示、推送的任何信息和内容如系云圈公司利用技术手段根据用户指令从互联网任何第三方网站搜索、定位、匹配后推荐给用户而非云圈公司单方制作的，则该显示、推送的信息和内容并不代表云圈公司及云圈<span\n" +
        "lang=EN-US>APP</span>的观点，云圈公司并不对上述信息的准确性和正确性负责。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>7.3</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司提供云圈<span lang=EN-US>APP</span>服务中所包含的任何文本、图片、标识、音频、视频资料均为教学用途，不涉及任何实体物品的商业活动。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>7.4</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈<span lang=EN-US>APP</span>在其页面上向用户显示、推送的任何信息和内容如存在侵权任何第三方知识产权的嫌疑，权利人和相关利害关系人应当向云圈公司发出权利通知，云圈公司经过核实后根据有关法律法规有权采取包括但不限于断开该侵权内容的链接或删除并停止传输该侵权内容，但云圈公司并不对该侵权内容承担法律责任。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>7.5</span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>用户违反本协议的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的律师费，用户同意赔偿云圈公司，使之免受损害。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        "background:white'><span class=pt><b><span lang=EN-US style='font-size:11.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#666666\'>8. </span></b></span><span\n' +
        'class=pt><b><span style=\'font-size:11.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#666666'>其他条款</span></b></span><span lang=EN-US style='font-size:10.5pt;\n" +
        'font-family:"微软雅黑","sans-serif";color:#818080\'><o:p></o:p></span></p>\n' +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>8.1 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>云圈公司有权随时修改本协议的任何条款，一旦本协议的内容发生变动，云圈公司将会在云圈<span lang=EN-US>APP</span>平台中公布修改后的协议内容或通过其他适当方式向用户公布修改内容。用户不同意上述修改内容，有权选择停止使用云圈服务，但用户继续使用，则视为接受云圈公司对本协议相关条款的修改。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>8.2 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>本《协议》所定的任何条款无论因何种原因部分或全部无效或不具有执行力，本协议的其余条款仍应有效并具备约束力。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>8.3 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>本协议的订立、执行和解释及纠纷的解决均应适用中华人民共和国法律并受中华人民共和国法院管辖。如双方就本协议内容或执行发生任何纠纷或争议，首先应友好协商解决，协商不成的，任何一方均可向云圈公司所在地的有管辖权的人民法院提起诉讼。<span\n" +
        "lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p style='margin:0cm;margin-bottom:.0001pt;text-indent:24.0pt;line-height:22.5pt;\n" +
        'background:white\'><span lang=EN-US style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        'color:#818080\'>8.4 </span><span style=\'font-size:10.5pt;font-family:"微软雅黑","sans-serif";\n' +
        "color:#818080'>本协议的版权归云圈公司所有，本协议各项条款内容的最终解释权及修改权归云圈公司所有。<span lang=EN-US><o:p></o:p></span></span></p>\n" +
        "\n" +
        "<p class=MsoNormal><span lang=EN-US><o:p>&nbsp;</o:p></span></p>\n" +
        "\n" +
        "</div>\n" +
        "\n" +
        "</body>\n" +
        "\n" +
        "</html>"
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 26px;
}
ol {
  float: left;
  margin-left: 20px;
  padding: 10px;
}
li {
  flex: 1;
  margin-top: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
p {
  color: #000;
  size: 26px;
  text-align: left;
  width: 100%;
  letter-spacing: 4px;
  line-height: 200%;
}
.hello {
  width: 100%;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/DiagnoseUserRuleTeacher.vue